module.exports = __webpack_public_path__ + "img/black-block.98cb0682.png";